import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import CompleteIcon from '@/assets/icons/icon_cp_complete.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';
import { hoverOpacity } from '@/utility/theme/animation';

export const List = styled.ol((props: { hasBorder: boolean }) =>
  mq({
    borderColor: defaultTheme.border.color.mediumLightGray,
    borderStyle: props.hasBorder ? 'solid none' : 'none',
    borderWidth: '1px',
  }),
);

export const ListItem = styled.li(() =>
  mq({
    borderBottom: `1px solid ${defaultTheme.border.color.mediumLightGray}`,
    '&:last-of-type': {
      border: 'none',
    },
  }),
);

export const StyledLink = styled(Link)(() =>
  mq({
    display: 'flex',
    width: '100%',
    padding: [
      `${defaultTheme.spacing.l} 0`,
      `${defaultTheme.spacing.l} 0`,
      `${defaultTheme.spacing.xxl} 0`,
      `${defaultTheme.spacing.xxl} 0`,
    ],
    ...hoverOpacity,
    '& > div:first-of-type': {
      marginRight: defaultTheme.spacing.l,
    },
  }),
);

export const TitleWrapper = styled.div((props: { isNews: boolean }) =>
  mq({
    display: 'grid',
    gridRowGap: [
      defaultTheme.spacing.xs,
      defaultTheme.spacing.xs,
      defaultTheme.spacing.m,
      defaultTheme.spacing.m,
    ],
    gridTemplateColumns: props.isNews
      ? ['1fr', '1fr', '138px 1fr', '138px 1fr']
      : '',
    width: '100%',
  }),
);

export const ItemTitle = styled.p(() =>
  mq({
    fontSize: [
      defaultTheme.font.size.s,
      defaultTheme.font.size.s,
      defaultTheme.font.size.m,
      defaultTheme.font.size.m,
    ],
    fontWeight: 'bold',
  }),
);

export const Thumbnail = styled.div((props: { isEntered: boolean }) =>
  mq({
    height: ['45px', '45px', '60px', '60px'],
    position: 'relative',
    borderRadius: defaultTheme.border.radius.xs,
    overflow: 'hidden',
    flex: '0 0 auto',
    '&:before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: '#000',
      zIndex: props.isEntered ? 2 : -1,
      opacity: props.isEntered ? 0.3 : 1,
    },
  }),
);

export const EntryStatus = styled.div((props: { isEntered: boolean }) =>
  mq({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: `${defaultTheme.spacing.xs} 0`,
    backgroundColor: props.isEntered
      ? defaultTheme.background.mediumGray
      : defaultTheme.background.white,
    border: `1px solid ${
      props.isEntered
        ? defaultTheme.background.mediumGray
        : defaultTheme.background.primary
    }`,
    borderRadius: defaultTheme.border.radius.xs,
    marginTop: defaultTheme.spacing.s,
    '& > span': {
      display: 'flex',
      alignItems: 'center',
      color: props.isEntered
        ? defaultTheme.color.white
        : defaultTheme.color.primary,
      fontSize: defaultTheme.font.size.xs,
      fontWeight: 'bold',
      '&:before': props.isEntered && {
        content: '""',
        display: 'inline-block',
        width: '12px',
        height: '12px',
        backgroundImage: `url(${CompleteIcon})`,
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        marginRight: defaultTheme.spacing.xs,
      },
    },
  }),
);
